import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { marketplaceClient, marketplaceBatchClient } from 'utils/graphql/client'
import { AppWrap } from 'apps/marketplace/components/AppWrap'
import { RouteNotFound } from 'components/404'
import { RedirectTo } from 'components/RedirectTo'
import Booking from './Booking'

export const appName = 'booking'

export function App() {
  const isGraphqlBatchingEnabled = useFeatureFlag('graphqlBatching')
  const apolloClient = isGraphqlBatchingEnabled ? marketplaceBatchClient : marketplaceClient

  return (
    <ApolloProvider client={apolloClient}>
      <AppWrap appName={appName} title='Shipments'>
        <Switch>
          <Route exact path='/' component={Booking} />
          <Route
            exact
            path='/:id'
            render={p => (
              <RedirectTo
                url={`${__ROOT__}/shipment-details/${p.match.params.id}?tab=scheduling`}
                history={p.history}
              />
            )}
          />
          <Route component={RouteNotFound} />
        </Switch>
      </AppWrap>
    </ApolloProvider>
  )
}

export default App
